<template>
    <div :class="alignment" style="margin-top: 5px;">
      <b-button size="sm"  @click.stop="showModal">Verification of Participation</b-button>
      <b-modal v-model="modalFlag" ok-only>
        <div class="text-center">
          <img src="@/art/viva_logo_ce.jpg" class="fluid" />
          <div class="txt-cert-title1">Viva Learning CE is the approved CE provider</div>
          <div class="txt-cert-title2">Verification of Participation</div>
        </div>
        <b-row align-h="center" class="mt-2">
          <b-col cols="12" lg="8">
            <div class="div-cert-body">
              <div>
                <b>Student's Name:</b> {{studentData.name}}
                <br><b>Course Title:</b> {{classObj.className}}
                <span v-if="classObj.speakerName !== null"><br><b>Lecturer:</b> {{classObj.speakerName}}</span>
                <br><b>Date Completed:</b> {{studentData.examDate | prettyDate}}
                <br><b>Method:</b> Electronically Mediated
                <!-- <br><b>Location:</b> Internet-based -->
                <br><b>Credit type:</b> {{studentData.ceTypeId | prettyCEType}}
                <br><b>Credit hour(s) earned:</b> {{studentData.credits}}
                <div v-if="classObj.agdCode"><b>AGD Subject Code:</b> {{classObj.agdCode}}</div>
                <br><b>Description and Learning Objectives:</b>
                <br><span v-bind:inner-html.prop="this.classObj.description | nl2br"></span>
                <!-- <br><span v-html="classObj.description"></span>  -->
              </div>
            </div>
          </b-col>
        </b-row>
        <div class="mt-2 div-cert-footer">
          <p>Viva Learning CE is in good standing with ADA CERP and AGD PACE:</p>

          <p>
          <b>ADA CERP Recognized Provider through June 30, 2023.</b> ADA CERP is a service of the American Dental Association to assist dental professionals in identifying quality providers of continuing dental education. ADA CERP does not approve or endorse individual courses or instructors, nor does it imply acceptance of credit hours by boards of dentistry. Concerns or complaints regarding this CE Program may be submitted via the webinar chat interface by clicking the Support link, or to ADA CERP at www.ada.org.
          </p>

          <p>
          <b>AGD PACE Approved Provider # 217544 through 10/31/2025.</b> The formal continuing education programs of this program provider are accepted by the AGD for Fellowship/Mastership and membership maintenance credit. Approval does not imply acceptance by a state or provincial board of dentistry or AGD endorsement. On a weekly basis your CE credits are automatically submitted to the AGD (requires AGD number entered in your Edit Profile page).
          </p>

          <p>
          <b>CPD for UK Participants:</b> This Verification of Participation is designed to satisfy GDC format related to CPD activity for UK participants.
          </p>
        </div>

        <transition name="fade" mode="out-in">
          <div>
            <b-alert v-model="error" key="error-box" show variant="danger" dismissible class="mt-2">
              {{errorMsg}}
            </b-alert>
            <b-alert v-model="success" key="success-box" show variant="success" dismissible class="mt-2">
              Check your email inbox for the Verification of Participation certificate.
            </b-alert>
          </div>
        </transition>

        <template v-slot:modal-footer>
          <div class="w-100 text-right">
            <b-overlay :show="busy">
              <b-button
                variant="primary"
                size="sm"
                @click="sendCert"
                class="mr-3"
              >
                Email to Me
              </b-button>
              <b-button
                variant="primary"
                size="sm"
                @click.stop.prevent="hideModal"
              >
                Close
              </b-button>
            </b-overlay>
          </div>
        </template>
      </b-modal>
    </div>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"

// Embedded due to init.
// var data = {
//   debug: false,
//  };

export default {
  name: "CertButton",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: null,
      busy: false,
      success: false,   // cert sent
      modalFlag: false,
      classObj: null,
      studentData: null
    }
  },
  props: {
    c: {  // classObj object
      type: Object,
      default: {}
    },
    s: {  // studentData object
      type: Object,
      default: {}
    },
    alignment: {  // bootstrap alignment: text-left, text-right, text-center
      type: String,
      default: 'text-center'
    }
  },
  computed: { },
  methods: {
    showModal() {
      this.busy = false
      this.success = false
      this.error = false
      this.errorMsg = null
      this.modalFlag = true
    },
    hideModal() {
      this.modalFlag = false
      this.busy = false
      this.success = false
      this.error = false
      this.errorMsg = null
    },
    sendCert() {
      this.busy = true
      this.success = false
      service
        .sendCert(this.studentData.hash, this.classObj.classHash, this.classObj.podcastHash)
        .then(res => {
          if (this.debug) console.log(res)
          if (res.status) {
            this.success = true
          } else {
            this.error = true
            this.errorMsg = res.errorMsg
          }
        })
        .finally(() => this.busy = false)
        .catch(e => console.log(e))
    }
  },
  created() {
    // console.log(`Created: cid: ${this.cid}  q: ${this.q} `)
    this.classObj = this.c || {status: false}   // represents class or podcast
    this.studentData = this.s || {status: false, hash: null, name: null, credits: 0, ceTypeId: 0}  // student data
  },
  mounted() {
    this.busy = false
    this.success = false
  },
  beforeDestroy() {}
}
</script>

<style scoped>
  .txt-cert-title1 {
    font-size: .9rem;
    font-weight: bold;
  }
  .txt-cert-title2 {
    font-size: 1.2rem;
    font-weight: bold;
  }
  .div-cert-body {
    text-align: left;
    font-size: .9rem;
  }
  .div-cert-footer {
    text-align: left;
    font-size: .6rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/CertButton.vue